var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsArrowLongRight = function SvgIconsArrowLongRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.293 4.293a1 1 0 0 0-.083 1.32l.083.094L16.585 11H5a1 1 0 0 0-.117 1.993L5 13h11.585l-5.292 5.293a1 1 0 0 0-.083 1.32l.083.094a1 1 0 0 0 1.32.083l.094-.083 7-7c.036-.035.068-.073.097-.112l.071-.11.054-.114.035-.105.025-.118.007-.058L20 12l-.003-.075-.017-.126-.03-.111-.044-.111-.052-.098-.064-.092-.083-.094-7-7a1 1 0 0 0-1.414 0z"
  })));
};
export default SvgIconsArrowLongRight;